import { createAction, props } from '@ngrx/store';

/**
 * Global State Actions
 * 
 * These actions are typically dispatched automatically by the meta-reducer,
 * but can also be dispatched manually if needed.
 */

/**
 * Indicates that an action has started loading
 */
export const startLoading = createAction(
    '[Global] Start Loading',
    props<{ actionType: string }>()
);

/**
 * Indicates that an action has finished loading (success or error)
 */
export const stopLoading = createAction(
    '[Global] Stop Loading',
    props<{ actionType: string }>()
);

/**
 * Clears all loading states
 */
export const clearAllLoading = createAction(
    '[Global] Clear All Loading'
);

/**
 * Sets a global error message
 */
export const setGlobalError = createAction(
    '[Global] Set Error',
    props<{ error: string }>()
);

/**
 * Clears the global error message
 */
export const clearGlobalError = createAction(
    '[Global] Clear Error'
);
